import LightggTooltips from '-!file-loader!./assets/tooltips.js';

export default function loadLightgg() {
  const existingScript = window.lgg;
  const options = {
    darkMode: true,
    renameLinks: true,
  };

  if (!existingScript) {
    const optionsScript = document.createElement('script');
    optionsScript.text = `
      window['lggTT'] = ${JSON.stringify(options)};
    `;
    document.body.appendChild(optionsScript);

    const script = document.createElement('script');
    script.src = LightggTooltips;
    document.body.appendChild(script);
  }
}



// WEBPACK FOOTER //
// ./components/html/thirdParty/LightGG/loadLightgg.js